<div class="table-container">
  <table mat-table [dataSource]="kfConfigurations" matSort>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.year" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.year}} </td>
    </ng-container>

    <ng-container matColumnDef="unuKeySetName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.UNU-key-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.unuKeySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="kfCategorySetName">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header> {{ "kf-reporting.key-figure-category-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.kfCategorySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="collectionStreamName">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header> {{ "kf-reporting.collection-stream-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.collectionStreamName}} </td>

    </ng-container>

    <ng-container matColumnDef="launched">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.launched" | translate }} </th>
      <td mat-cell *matCellDef="let config">
        {{config.launched ? config.launched : (config.lifeCycleStatus ? capitalize(config.lifeCycleStatus) : 'Not started')}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let config">
        <mat-icon color="primary" (click)="goToEdit(config)">edit</mat-icon>
        <mat-icon *ngIf="config.launched" (click)="print(config)" color="primary">print</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
